import { render, staticRenderFns } from "./GerenciarUsuarios.vue?vue&type=template&id=2c03468d&scoped=true"
import script from "./GerenciarUsuarios.vue?vue&type=script&lang=js"
export * from "./GerenciarUsuarios.vue?vue&type=script&lang=js"
import style0 from "./GerenciarUsuarios.vue?vue&type=style&index=0&id=2c03468d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c03468d",
  null
  
)

export default component.exports